// extracted by mini-css-extract-plugin
export default {"container":"aI7Ic8XRRG_2NvstEhE8","configBox":"MTyhj34UBIYYjmFBX3O5","inputButton":"O9dMhLXzkg9Vs58DHyXP","disclaimer":"Az2BbqYexoQbRSABoWHJ"};